import { CurveType } from "recharts/types/shape/Curve";

interface linesInterface {
    type: CurveType;
    dataKey: string;
    color: string;
}

export const lines: linesInterface[] = [
    {
        type: "linear",
        dataKey: "N",
        color: "#269FFC",
    },
    {
        type: "linear",
        dataKey: "P",
        color: "#08AE5D",
    },
    {
        type: "linear",
        dataKey: "K",
        color: "#FCB704",
    },
];

export const bars: linesInterface[] = [
    {
        type: "linear",
        dataKey: "N",
        color: "#269FFC",
    },
    {
        type: "linear",
        dataKey: "P",
        color: "#08AE5D",
    },
    {
        type: "linear",
        dataKey: "K",
        color: "#FCB704",
    },
];
